import { atom } from 'jotai';
import { HighlightedVideo, Video } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type ErsteMarketMediaHubAtomState = {
  videos: LoadableState<Video[]>;
  highlightedVideo: LoadableState<HighlightedVideo | undefined>;
  hasMore: boolean;
  currentPage: number;
};

export const ersteMarketMediaHubAtom = atom<ErsteMarketMediaHubAtomState>({
  videos: Loadable.uninitialized,
  highlightedVideo: Loadable.uninitialized,
  hasMore: true,
  currentPage: 1,
});
